import { api } from "./../api";
import { ApiPaths } from "./../api/paths";
import { ISignInRequestData, ISignUpRequestData } from "./../../store/auth/types";
import {
    GetGuestTokensResponse,
    SignInRequestResponse,
    SignUpRequestResponse,
    RefreshTokenRequestResponse,
    ConfirmUserRequestResponse,
    ForgotPasswordRequestResponse,
    IGoogleLoginRequest,
    GoogleLoginBEResponse,
    OAuthFlowCheckParamsRequest,
    OAuthFlowCheckUserRequest,
    OAuthFlowGetCodeRequest,
} from "./auth.service.d";

export class AuthService {
    /**
     * Sign in request
     *
     * @param  no_params
     */
    static async getGuestTokens(): Promise<GetGuestTokensResponse> {
        return api.post(ApiPaths.SIGN_IN);
    }

    /**
     * Sign in request
     *
     * @param  {ISignInData} signInData
     */
    static async signIn(signInData: ISignInRequestData): Promise<SignInRequestResponse> {
        return api.post(ApiPaths.SIGN_IN, signInData);
    }

    /**
     * Sign up request
     *
     * @param  {ISignUpData} signUpData
     */
    static async signUp(signUpData: ISignUpRequestData): Promise<SignUpRequestResponse> {
        return api.post(ApiPaths.SIGN_UP, signUpData);
    }

    /**
     * refresh Token
     *
     * @param  {string} refresh_token
     */
    static async refreshToken(refresh_token: string): Promise<RefreshTokenRequestResponse> {
        return api.post(ApiPaths.REFRESH_TOKEN, { refresh_token });
    }

    /**
     * refresh Token
     *
     * @param  {string} code
     */
    static async confirmUser(code: string): Promise<ConfirmUserRequestResponse> {
        return api.post(ApiPaths.CONFIRM_USER, { code });
    }

    /**
     * Sign in request
     *
     * @param  no_params //FIX
     */
    static async forgotPassword(data: { redirect_url: string; email: string }): Promise<ForgotPasswordRequestResponse> {
        return api.post(ApiPaths.FORGOT_PASSWORD, data);
    }
    /**
     * Init Google Logged User
     *
     * @param  {IGoogleLoginRequest} data
     */
    static async initGoogleLoggedUser(data: IGoogleLoginRequest): Promise<GoogleLoginBEResponse> {
        return api.post(ApiPaths.GOOGLE_LOGIN, data);
    }

    /* OAuth */

    static async checkRecivedParams(
        client_id: string,
        redirect_url: string,
        response_type: string,
    ): Promise<OAuthFlowCheckParamsRequest> {
        return api.get(ApiPaths.CHECK_PARAMS, {
            params: {
                client_id,
                redirect_url,
                response_type,
            },
        });
    }

    static async checkUser(email: string, password: string): Promise<OAuthFlowCheckUserRequest> {
        return api.get(ApiPaths.CHECK_USER, {
            params: {
                email,
                password,
                type: "Basic",
            },
        });
    }

    static async getRedirectUrl({
        client_id,
        redirect_url,
        email,
        password,
        state,
        scope,
    }: {
        client_id: string;
        redirect_url: string;
        email: string;
        password: string;
        state?: string;
        scope?: string;
    }): Promise<OAuthFlowGetCodeRequest> {
        return api.post(ApiPaths.GET_REDIRECT_URL, {
            client_id,
            redirect_uri: redirect_url,
            email,
            password,
            type: "Basic",
            response_type: "code",
            state,
            scope,
        });
    }
}
